import Vue from 'vue'
import App from './App.vue'
import router from './router/router.js'
import store from './store/store.js'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueYoutube from 'vue-youtube'
Vue.use(VueYoutube)
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

import YmapPlugin from 'vue-yandex-maps'

Vue.use(YmapPlugin)
import VueMask from 'v-mask'
Vue.use(VueMask);


import VueFroala from 'vue-froala-wysiwyg'
//Import Froala Editor 
import 'froala-editor/js/plugins.pkgd.min.js';
//Import third party plugins
import 'froala-editor/js/third_party/embedly.min';
import 'froala-editor/js/third_party/font_awesome.min';
import 'froala-editor/js/third_party/spell_checker.min';
import 'froala-editor/js/third_party/image_tui.min';
// Import Froala Editor css files.
import 'froala-editor/css/froala_editor.pkgd.min.css';
Vue.use(VueFroala)
import ApiService from './services/api.service';
import { TokenService } from './services/storage.service';

// SET THE BASE_URL OF THE API
ApiService.init(process.env.VUE_APP_ROOT_API);
ApiService.mount401Interceptor();

import Util from './core/plugins/globalMethods'
Vue.prototype.$toLatin = Util.toLatin
Vue.prototype.$toCyrill = Util.toCyrill
Vue.prototype.$localeKey = Util.localeKey
Vue.prototype.$answerDocHtml = Util.answerDocHtml
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

// import Util from './core/plugins/globalMethods'
// Vue.prototype.$toLatin = Util.toLatin
// Vue.prototype.$toCyrill = Util.toCyrill
let options = {
    timeout: 2000,
    icon: true,
    position: 'top-right',
}
Vue.use(Toast, options)

// IF TOKEN EXISTS SET HEADER
if (TokenService.getToken()) {
    ApiService.setHeader();
    ApiService.mount401Interceptor();
}

// V_SELECT
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
Vue.component('vue-select', vSelect)

export const bus = new Vue();
// I18n

import VueCountdownTimer from 'vuejs-countdown-timer';
Vue.use(VueCountdownTimer);
import i18n from "./core/plugins/vue-i18n";

Vue.config.productionTip = true
import common from './common'
Vue.mixin(common)
new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
